
export const SIGNS = [
      { name: 'Capricorne', emoji: '♑', start: { m: 12, d: 22 }, end: { m: 1, d: 19 } },
      { name: 'Verseau', emoji: '♒', start: { m: 1, d: 20 }, end: { m: 2, d: 18 } },
      { name: 'Poissons', emoji: '♓', start: { m: 2, d: 19 }, end: { m: 3, d: 20 } },
      { name: 'Bélier', emoji: '♈', start: { m: 3, d: 21 }, end: { m: 4, d: 19 } },
      { name: 'Taureau', emoji: '♉', start: { m: 4, d: 20 }, end: { m: 5, d: 20 } },
      { name: 'Gémeaux', emoji: '♊', start: { m: 5, d: 21 }, end: { m: 6, d: 20 } },
      { name: 'Cancer', emoji: '♋', start: { m: 6, d: 21 }, end: { m: 7, d: 22 } },
      { name: 'Lion', emoji: '♌', start: { m: 7, d: 23 }, end: { m: 8, d: 22 } },
      { name: 'Vierge', emoji: '♍', start: { m: 8, d: 23 }, end: { m: 9, d: 22 } },
      { name: 'Balance', emoji: '♎', start: { m: 9, d: 23 }, end: { m: 10, d: 22 } },
      { name: 'Scorpion', emoji: '♏', start: { m: 10, d: 23 }, end: { m: 11, d: 21 } },
      { name: 'Sagittaire', emoji: '♐', start: { m: 11, d: 22 }, end: { m: 12, d: 21 } }
    ];